<template>
    <div class="top-players">
        <div class="title-contents">
            <div class="icon-holder">
                <img src="@/assets/icons/star.svg" alt="">
            </div>
            <h2>Рейтинг по серверу</h2>
        </div>
        <params_of_search :params="top || {}" :active="activeTab || ''" @change="activeTab = $event"/>
        <player_list :list="activeTop.top" :key-val="activeTab || ''"/>
    </div>
</template>

<script>
    import params_of_search from './params_of_search.vue'
    import player_list from './player_list.vue'
    import {mapActions, mapMutations, mapState} from "vuex";

    export default {
        name: "top_players",
        components: {
            params_of_search,
            player_list,
        },
        data: ()=>({
            activeTab: false
        }),
        computed: {
            activeTop(){
                if(!this.top) return {};
                else return this.top[this.activeTab] || {};
            },
            ...mapState('cabinet', ['top'])
        },
        methods: {
            ...mapMutations('loading_progress',['startLoading', 'finishLoading']),
            ...mapActions('cabinet', ['getTop']),
        },
        created(){
            if(!this.top){
                this.startLoading();
                this.getTop().then(()=>{
                   this.activeTab = Object.keys(this.top)[0];
                }).finally(()=>{
                    this.finishLoading();
                });
            }
            else if(!this.activeTab) {
                this.activeTab = Object.keys(this.top)[0];
            }
        }
    }
</script>

<style scoped lang="scss">
    .top-players {

    }
</style>
